module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "window",
    attrs: {
      "id": "#description-code"
    }
  }, [_c('div', {
    staticClass: "bar"
  }, [_c('div', {
    staticClass: "dot close"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot minimize",
    on: {
      "click": function($event) {
        _vm.minimize('#description-code')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dot expand"
  })]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_vm._v("    "), _c('code', {
    staticClass: "hljs",
    domProps: {
      "innerHTML": _vm._s(_vm.computedCode)
    }
  }, [_vm._v(" \n    ")]), _vm._v("\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60cc08eb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/window.vue
// module id = 273
// module chunks = 2